var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { useMutation, useQuery } from '@tanstack/react-query';
import { giveawaysMutationKeys, giveawaysQueryKeys } from 'root/src/shared/giveaways/giveaways.keys';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
export const useEditScheduleMutation = () => {
    const { fetcher } = useDareDropApi();
    return useMutation({
        mutationKey: giveawaysMutationKeys.updateGiveawaysSchedulerMutationKeySelector(),
        mutationFn: (params) => __awaiter(void 0, void 0, void 0, function* () {
            return fetcher({
                endpointId: giveawayEndpointIds.UPDATE_USER_GIVEAWAY_SCHEDULER,
                payload: {
                    id: params.id,
                    durationTime: params.durationTime,
                    repeatTimes: params.repeatTimes,
                    status: params.status,
                    configId: params.configId,
                },
            });
        }),
    });
};
export const useScheduleQuery = () => {
    const { fetcher } = useDareDropApi();
    return useQuery({
        queryKey: giveawaysQueryKeys.giveawaysSchedulerQueryKeySelector(),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            return fetcher({
                endpointId: giveawayEndpointIds.GET_USER_ACTIVE_GIVEAWAY_SCHEDULER,
                payload: {
                    userId: getCookie('userId'),
                },
            });
        }),
    });
};
export const useCreateScheduleMutation = () => {
    const { fetcher } = useDareDropApi();
    return useMutation({
        mutationKey: giveawaysMutationKeys.createGiveawaysSchedulerMutationKeySelector(),
        mutationFn: (params) => __awaiter(void 0, void 0, void 0, function* () {
            return fetcher({
                endpointId: giveawayEndpointIds.CREATE_GIVEAWAY_SCHEDULE,
                payload: {
                    durationTime: params.durationTime,
                    repeatTimes: params.repeatTimes,
                    configId: params.configId,
                },
            });
        }),
    });
};
